import React from "react";
import { Eyebrow } from "./Eyebrow";
import { SectionHeading } from "./Heading";

type PageHeaderProps = {
  /** Small uppercase tag rendered above the title (e.g. "— Today / Engine activity"). */
  eyebrow?: React.ReactNode;
  /** The page's display heading. Pass JSX so consumers control gradients / em-lines.
   * Optional — pages whose eyebrow already conveys the page name (and would
   * otherwise duplicate it) may omit this. */
  title?: React.ReactNode;
  /** Sub-line below the title — date stamps, last-updated text, status pills. */
  meta?: React.ReactNode;
  /** Right-side block: account switcher, page-level controls (switches, buttons). */
  right?: React.ReactNode;
  className?: string;
};

/**
 * Standard TrueReel page header — eyebrow + section heading + meta on the left,
 * controls slot on the right. Used at the top of every product / dashboard page
 * (Today, Portfolio, Runs, Strategies). The shape is the same; the slots vary.
 */
export function PageHeader({
  eyebrow,
  title,
  meta,
  right,
  className,
}: PageHeaderProps) {
  const cls = ["tb-pagehead", className].filter(Boolean).join(" ");
  return (
    <header className={cls}>
      <div className="tb-pagehead-l">
        {eyebrow ? <Eyebrow>{eyebrow}</Eyebrow> : null}
        {title ? <SectionHeading>{title}</SectionHeading> : null}
        {meta ? <div className="tb-pagehead-meta">{meta}</div> : null}
      </div>
      {right ? <div className="tb-pagehead-r">{right}</div> : null}
    </header>
  );
}
